"use strict";function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(exports,"__esModule",{value:!0});var DefaultStorage=exports.DefaultStorage=function t(){var e=this;_classCallCheck(this,t),this.getItem=function(t){return Promise.resolve(e.storage.getItem(t))},this.setItem=function(t,r){return Promise.resolve(e.storage.setItem(t,r))},this.getObject=function(t){return e.getItem(t).then(function(t){return t&&JSON.parse(t)})},this.setObject=function(t,r){return e.setItem(t,JSON.stringify(r))},this.storage=window.SyncedStorage||window.localStorage};
//# sourceMappingURL=defaultStorage.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@convotis/liferay-client/lib/plugins/defaultStorage.js
// module id = 173
// module chunks = 4